export const jobsSelector = state => state.jobs;
